/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AbpPtwExceptionHttpResponseModel,
  CreateOrUpdateJobConfigurationDto,
  GetUpdatedTaskItemsDto,
  JobConfigurationDto,
  ODataPostProcessedResultsOfJobConfigurationDto,
  ODataPostProcessedResultsOfTaskInJobDto,
  TaskInJobDto,
} from '../models/index';
import {
    AbpPtwExceptionHttpResponseModelFromJSON,
    AbpPtwExceptionHttpResponseModelToJSON,
    CreateOrUpdateJobConfigurationDtoFromJSON,
    CreateOrUpdateJobConfigurationDtoToJSON,
    GetUpdatedTaskItemsDtoFromJSON,
    GetUpdatedTaskItemsDtoToJSON,
    JobConfigurationDtoFromJSON,
    JobConfigurationDtoToJSON,
    ODataPostProcessedResultsOfJobConfigurationDtoFromJSON,
    ODataPostProcessedResultsOfJobConfigurationDtoToJSON,
    ODataPostProcessedResultsOfTaskInJobDtoFromJSON,
    ODataPostProcessedResultsOfTaskInJobDtoToJSON,
    TaskInJobDtoFromJSON,
    TaskInJobDtoToJSON,
} from '../models/index';

export interface CreateJobConfigurationRequest {
    createOrUpdateJobConfigurationDto?: CreateOrUpdateJobConfigurationDto;
}

export interface DeleteJobConfigurationRequest {
    id: string;
}

export interface GetAllTaskItemsRequest {
    medicalSystemId: string;
    $filter?: string;
    $search?: string;
    $top?: number;
    $skip?: number;
    $orderby?: string;
}

export interface GetJobConfigurationRequest {
    id: string;
}

export interface GetJobConfigurationListRequest {
    $filter?: string;
    $search?: string;
    $top?: number;
    $skip?: number;
    $orderby?: string;
}

export interface GetTaskInJobDtoRequest {
    taskAreaId: string;
}

export interface GetUpdatedTaskItemsRequest {
    getUpdatedTaskItemsDto?: GetUpdatedTaskItemsDto;
}

export interface UpdateJobConfigurationRequest {
    id: string;
    createOrUpdateJobConfigurationDto?: CreateOrUpdateJobConfigurationDto;
}

export interface ValidateJobConfigurationRequest {
    createOrUpdateJobConfigurationDto?: CreateOrUpdateJobConfigurationDto;
}

/**
 * 
 */
export class JobConfigurationsApi extends runtime.BaseAPI {

    /**
     * Adds a new entity
     */
    async createJobConfigurationRaw(requestParameters: CreateJobConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JobConfigurationDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/job-configurations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdateJobConfigurationDtoToJSON(requestParameters.createOrUpdateJobConfigurationDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => JobConfigurationDtoFromJSON(jsonValue));
    }

    /**
     * Adds a new entity
     */
    async createJobConfiguration(requestParameters: CreateJobConfigurationRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.createJobConfigurationRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<JobConfigurationDto>(response, errorHandlers);
    }

    /**
     * Deletes the entity with the given id.
     */
    async deleteJobConfigurationRaw(requestParameters: DeleteJobConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteJobConfiguration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/job-configurations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes the entity with the given id.
     */
    async deleteJobConfiguration(requestParameters: DeleteJobConfigurationRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.deleteJobConfigurationRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     */
    async getAllTaskItemsRaw(requestParameters: GetAllTaskItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ODataPostProcessedResultsOfTaskInJobDto>> {
        if (requestParameters.medicalSystemId === null || requestParameters.medicalSystemId === undefined) {
            throw new runtime.RequiredError('medicalSystemId','Required parameter requestParameters.medicalSystemId was null or undefined when calling getAllTaskItems.');
        }

        const queryParameters: any = {};

        if (requestParameters.$filter !== undefined) {
            queryParameters['$filter'] = requestParameters.$filter;
        }

        if (requestParameters.$search !== undefined) {
            queryParameters['$search'] = requestParameters.$search;
        }

        if (requestParameters.$top !== undefined) {
            queryParameters['$top'] = requestParameters.$top;
        }

        if (requestParameters.$skip !== undefined) {
            queryParameters['$skip'] = requestParameters.$skip;
        }

        if (requestParameters.$orderby !== undefined) {
            queryParameters['$orderby'] = requestParameters.$orderby;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/job-configurations/task-items/{medicalSystemId}`.replace(`{${"medicalSystemId"}}`, encodeURIComponent(String(requestParameters.medicalSystemId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => ODataPostProcessedResultsOfTaskInJobDtoFromJSON(jsonValue));
    }

    /**
     */
    async getAllTaskItems(requestParameters: GetAllTaskItemsRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getAllTaskItemsRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<ODataPostProcessedResultsOfTaskInJobDto>(response, errorHandlers);
    }

    /**
     * Returns one entity for detail view.
     */
    async getJobConfigurationRaw(requestParameters: GetJobConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JobConfigurationDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getJobConfiguration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/job-configurations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => JobConfigurationDtoFromJSON(jsonValue));
    }

    /**
     * Returns one entity for detail view.
     */
    async getJobConfiguration(requestParameters: GetJobConfigurationRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getJobConfigurationRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<JobConfigurationDto>(response, errorHandlers);
    }

    /**
     * Returns a list of entities for grid view.
     */
    async getJobConfigurationListRaw(requestParameters: GetJobConfigurationListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ODataPostProcessedResultsOfJobConfigurationDto>> {
        const queryParameters: any = {};

        if (requestParameters.$filter !== undefined) {
            queryParameters['$filter'] = requestParameters.$filter;
        }

        if (requestParameters.$search !== undefined) {
            queryParameters['$search'] = requestParameters.$search;
        }

        if (requestParameters.$top !== undefined) {
            queryParameters['$top'] = requestParameters.$top;
        }

        if (requestParameters.$skip !== undefined) {
            queryParameters['$skip'] = requestParameters.$skip;
        }

        if (requestParameters.$orderby !== undefined) {
            queryParameters['$orderby'] = requestParameters.$orderby;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/job-configurations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => ODataPostProcessedResultsOfJobConfigurationDtoFromJSON(jsonValue));
    }

    /**
     * Returns a list of entities for grid view.
     */
    async getJobConfigurationList(requestParameters: GetJobConfigurationListRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getJobConfigurationListRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<ODataPostProcessedResultsOfJobConfigurationDto>(response, errorHandlers);
    }

    /**
     */
    async getTaskInJobDtoRaw(requestParameters: GetTaskInJobDtoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TaskInJobDto>> {
        if (requestParameters.taskAreaId === null || requestParameters.taskAreaId === undefined) {
            throw new runtime.RequiredError('taskAreaId','Required parameter requestParameters.taskAreaId was null or undefined when calling getTaskInJobDto.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/job-configurations/task-in-job/{taskAreaId}`.replace(`{${"taskAreaId"}}`, encodeURIComponent(String(requestParameters.taskAreaId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => TaskInJobDtoFromJSON(jsonValue));
    }

    /**
     */
    async getTaskInJobDto(requestParameters: GetTaskInJobDtoRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getTaskInJobDtoRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<TaskInJobDto>(response, errorHandlers);
    }

    /**
     */
    async getUpdatedTaskItemsRaw(requestParameters: GetUpdatedTaskItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TaskInJobDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/job-configurations/task-items`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetUpdatedTaskItemsDtoToJSON(requestParameters.getUpdatedTaskItemsDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TaskInJobDtoFromJSON));
    }

    /**
     */
    async getUpdatedTaskItems(requestParameters: GetUpdatedTaskItemsRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getUpdatedTaskItemsRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<Array<TaskInJobDto>>(response, errorHandlers);
    }

    /**
     * Updates an entity, if existing
     */
    async updateJobConfigurationRaw(requestParameters: UpdateJobConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JobConfigurationDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateJobConfiguration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/job-configurations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdateJobConfigurationDtoToJSON(requestParameters.createOrUpdateJobConfigurationDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => JobConfigurationDtoFromJSON(jsonValue));
    }

    /**
     * Updates an entity, if existing
     */
    async updateJobConfiguration(requestParameters: UpdateJobConfigurationRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.updateJobConfigurationRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<JobConfigurationDto>(response, errorHandlers);
    }

    /**
     */
    async validateJobConfigurationRaw(requestParameters: ValidateJobConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/job-configurations/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdateJobConfigurationDtoToJSON(requestParameters.createOrUpdateJobConfigurationDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async validateJobConfiguration(requestParameters: ValidateJobConfigurationRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.validateJobConfigurationRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

}
